import { render } from "./App.vue?vue&type=template&id=51919d90"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=51919d90&lang=postcss"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__